<template>
  <transition name="toast-fade">
    <div v-if="visible" class="fixed top-5 left-1/2 -translate-x-1/2 bg-gray-800 text-white py-2 px-4 rounded-lg shadow-lg z-[100]">
      {{ message }}
    </div>
  </transition>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
  message: String,
  duration: {
    type: Number,
    default: 3000
  }
});

const visible = ref(false);

onMounted(() => {
  visible.value = true;
  setTimeout(() => {
    visible.value = false;
  }, props.duration);
});
</script>

<style scoped>
.toast-fade-enter-active, .toast-fade-leave-active {
  transition: opacity 0.5s;
}
.toast-fade-enter, .toast-fade-leave-to /* .toast-fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
</style>